export class RemoteConfigList {
    constructor(remoteConfigs) {
        this.remoteConfigs = remoteConfigs;
    }
    remoteConfigForContextKey(contextKey) {
        return this.findRemoteConfigForContextKey(contextKey);
    }
    remoteConfigForEmptyContextKey() {
        return this.findRemoteConfigForContextKey(null);
    }
    findRemoteConfigForContextKey(contextKey) {
        return this.remoteConfigs.find(config => config.source.contextKey == contextKey);
    }
}
//# sourceMappingURL=RemoteConfigList.js.map